import { QuestionStructure } from './question-structure.model';

export interface QuestionStructureFileUpload extends QuestionStructure {
  maxFileSize: number;
  handlingstyp: string;
  maxNumberOfPages: number;
}

export const FileUploadStructureName = {
  MaxFileSize: 'maxFileSize',
  Handlingstyp: 'handlingstyp',
  MaxNumberOfPages: 'maxNumberOfPages',
} as const;
